<template>
    <div id="experience" class="py-20">
        <Carousel v-if="!isMobile" :source="source.carousel" :title="source.title" />
        <CarouselMobile v-else :source="source.carousel" :title="source.title" class="!mt-0" />
    </div>
</template>

<script lang="ts" setup>
import Carousel from "@/pages/hardware/vs-competitors/components/Carousel.vue";
import CarouselMobile from "@/pages/hardware/vs-competitors/components/CarouselMobile.vue";
import { useIsMobile } from "@/hooks/useIsMobile";
const isMobile = useIsMobile();
defineProps<{ source: any }>();
</script>

<style lang="scss" scoped></style>
